import { Community } from '@/mocks/communities';

interface CommunityAboutProps {
  community: Community;
}

const highlights = [
  { icon: 'ri-shield-check-line', label: 'Verified Community', color: 'text-emerald-500' },
  { icon: 'ri-spam-2-line', label: 'Anti-Spam Protected', color: 'text-[#0088CC]' },
  { icon: 'ri-user-star-line', label: 'Active Moderation', color: 'text-amber-500' },
  { icon: 'ri-links-line', label: 'Open to Join', color: 'text-slate-500' },
];

export default function CommunityAbout({ community }: CommunityAboutProps) {
  return (
    <div className="bg-white/50 backdrop-blur-md rounded-2xl border border-white/80 p-6">
      <h2 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
        <span className="w-6 h-6 flex items-center justify-center text-[#0088CC]">
          <i className="ri-information-line text-base"></i>
        </span>
        About This Community
      </h2>

      <p className="text-sm text-slate-600 leading-relaxed mb-5">
        {community.longDescription || community.description}
      </p>

      {/* Highlights */}
      <div className="grid grid-cols-2 gap-2">
        {highlights.map((h) => (
          <div key={h.label} className="flex items-center gap-2.5 bg-white/60 backdrop-blur-sm rounded-xl border border-[#c5d9eb]/40 px-3 py-2.5">
            <span className={`w-5 h-5 flex items-center justify-center shrink-0 ${h.color}`}>
              <i className={`${h.icon} text-sm`}></i>
            </span>
            <span className="text-xs text-slate-600 font-medium">{h.label}</span>
          </div>
        ))}
      </div>

      {/* Community Rules teaser */}
      <div className="mt-5 bg-[#0088CC]/5 border border-[#0088CC]/15 rounded-xl p-4">
        <h3 className="text-sm font-semibold text-slate-700 mb-2 flex items-center gap-2">
          <span className="w-4 h-4 flex items-center justify-center text-[#0088CC]">
            <i className="ri-file-list-3-line text-sm"></i>
          </span>
          Community Guidelines
        </h3>
        <ul className="flex flex-col gap-1.5">
          {[
            'Be respectful and constructive in all discussions',
            'No spam, self-promotion without permission',
            'Stay on-topic — keep content relevant to the community',
            'No hate speech, harassment, or offensive content',
          ].map((rule, i) => (
            <li key={i} className="flex items-start gap-2 text-xs text-slate-500">
              <span className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                <i className="ri-checkbox-circle-line text-[#0088CC] text-xs"></i>
              </span>
              {rule}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
